import fetch from "cross-fetch";
import {setConversionRates} from "../Actions";

export const getUSDfromBTC = (btc, rates) => {
  return parseFloat(btc * rates.BTCUSD).toFixed(2);
}

export const getBTCfromUSD = (usd, rates) => {
  return parseFloat(usd / rates.BTCUSD).toFixed(8);
}

export const updateRates = (dispatch) => new Promise((resolve, reject) => {
  fetch('https://blockchain.info/ticker?cors=true')
    .then(response => response.json())
    .then((ticker) => dispatch(setConversionRates({
      BTCUSD: ticker['USD']['last'],
      BTCEUR: ticker['EUR']['last']
    })))
    .then( resolve )
    .catch( reject );
});


// WEBPACK FOOTER //
// ./src/Helpers/conversion.js